import { v4 as uuid } from 'uuid';
import { PayloadAction } from '@reduxjs/toolkit';
import { StaticVideo } from '@/types/video.types';
import { ContentReducerCreator } from '../types';

const createUploadJobReducer = (create: ContentReducerCreator) => {
  return create.reducer(
    (state, action: PayloadAction<{ onStarted?: () => void; onComplete: (video: StaticVideo) => void }>) => {
      state.uploadJobs = [
        ...state.uploadJobs,
        {
          fileSelected: false,
          uploading: false,
          onStarted: action.payload.onStarted,
          onComplete: action.payload.onComplete,
          uuid: uuid(),
        },
      ];
    }
  );
};

export default createUploadJobReducer;
